import {
  File,
  FileImage,
  FileText,
  FileVideo,
  FileArchive,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const EXTENSION_ICON_MAP: Record<string, LucideIcon> = {
  // Images
  png: FileImage,
  jpg: FileImage,
  jpeg: FileImage,
  gif: FileImage,
  webp: FileImage,
  svg: FileImage,
  bmp: FileImage,
  avif: FileImage,
  // Documents
  pdf: FileText,
  doc: FileText,
  docx: FileText,
  txt: FileText,
  md: FileText,
  csv: FileText,
  xls: FileText,
  xlsx: FileText,
  // Video
  mp4: FileVideo,
  avi: FileVideo,
  mov: FileVideo,
  mkv: FileVideo,
  webm: FileVideo,
  // Archives
  zip: FileArchive,
  rar: FileArchive,
  gz: FileArchive,
  "7z": FileArchive,
  tar: FileArchive,
};

function getIconForFilename(filename: string): LucideIcon {
  const dot = filename.lastIndexOf(".");
  if (dot === -1) return File;
  const ext = filename.slice(dot + 1).toLowerCase();
  return EXTENSION_ICON_MAP[ext] ?? File;
}

interface FileTypeIconProps {
  filename: string;
  className?: string;
}

export function FileTypeIcon({ filename, className }: FileTypeIconProps) {
  const Icon = getIconForFilename(filename);
  return <Icon className={cn("h-4 w-4", className)} />;
}
